import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useStore } from 'src/stores';
import { observer } from 'mobx-react-lite';
// import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
import CreateAccountModal from 'src/pages/AdminPage/CreateAccountModal';
import { PaymentsAndSubscriptionsContent } from './paymentsAndSubscriptionsContent';
export const PaymentsAndSubscriptions = observer(() => {
  // const { t } = useTranslation();
  const store = useStore();
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isCreateAccountModal = _useState2[0],
    setIsCreateAccountModal = _useState2[1];
  const fetchPortfoliosDataGeneralUpdateTrigger = async customUnicIds => {
    if (store.admin.companyId) {
      await store.portfolios.getPortfoliosDashboardAsync.run({
        storeCompany: true
      }, !customUnicIds && !(customUnicIds !== null && customUnicIds !== void 0 && customUnicIds.length) && store.homeDashboardStore.companyAccessId !== null ? [store.homeDashboardStore.companyAccessId] : !!(customUnicIds !== null && customUnicIds !== void 0 && customUnicIds.length) ? customUnicIds : null);
    }
  };
  useEffect(() => {
    store.account.getProfileAsync.run(false);
    fetchPortfoliosDataGeneralUpdateTrigger();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PaymentsAndSubscriptionsContent, {
    handleOpenCreateAccountModal: () => setIsCreateAccountModal(true)
  }), /*#__PURE__*/React.createElement(CreateAccountModal, {
    isOpen: isCreateAccountModal,
    handleClose: () => setIsCreateAccountModal(false),
    trigger: null
  }));
});